<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">
                <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                  [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                  [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" (keydown.enter)="getBusinessFilter(searchVal)" placeholder="Search" #name
                        [(ngModel)]="searchVal" />
                      <button class="btn search-btn glow position-absolute" (click)="getBusinessFilter(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/business/add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Business Guideline</button>
                  </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Name" prop="name" width="140">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="display_flex">
                  <div class="d-flex align-items-center">
                    <div class="avatar mr-1 ml-0 bg-primary">
											<div class="avatar-content">
											  {{ row?.name | shortName }}
											</div>
										</div>
                     <!-- --------- card ------------------------------------ -->
                     <div class="card-overlay-on-hover">
                      <div class="card">
                        <div class="card-content">
                          <div class="card-img">
                            <div  class="avatarImg mr-1 ml-0">
                              <div class="avatar-contentImg">{{ row?.name | shortName }}</div>
                            </div>
                          </div>
                          <div class="card-body p-0">
                            <h5>{{row?.address}}</h5>
                            <p id="p-tag">{{row?.facebook_url}}</p>
                            <p id="p-tag">{{row?.linked_url}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ---------------------------------------------------------- -->
                   
                   
                  </div>
                  <div class="cell-line-height cursor-pointer">
                  <p class="font-medium-1 line-height-1 mb-0" (click)="openModal(myModal,row?.name,row?.refrences)">
                    {{ row?.name }}
                  </p>
                </div>
                  </div>

                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Email" prop="email" width="120">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p id="p-tag">{{row?.email}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Phone" prop="phone" width="40"></ngx-datatable-column>
              <ngx-datatable-column name="Website" prop="website" width="50">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p id="p-tag">{{row?.website}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Type" prop="type" width="10"></ngx-datatable-column>

              <ngx-datatable-column name="Actions"  width="10"
                *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i mat-button [matMenuTriggerFor]="menu"
                    class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item [routerLink]="['/business/edit', row._id]"
                      (click)="editBusiness(row._id)">Edit</button>
                      <button  mat-menu-item (click)="addContact(row?._id)">Add Contact</button>
                      <button  mat-menu-item (click)="openContactModal(myModalContact,row)">View Contact</button>
                      <button *ngIf="user_role.roles =='admin'" mat-menu-item (click)="ConfirmColor(row._id)">Delete</button>

                    </mat-menu>
                  <!-- <i class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/business/edit', row._id]"
                    (click)="editBusiness(row._id)"></i>
                  <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                    (click)="ConfirmColor(row._id)"></i> -->
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Active" prop="is_activated" width="5">
                <ng-template let-row="row" ngx-datatable-cell-template>

                  <div class="custom-switch custom-control-inline mb-1 mb-xl-0">
                    <mat-slide-toggle color="primary" [checked]="row.is_activated"
                      (change)="activateBusiness(row)"></mat-slide-toggle>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              
            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

<!-------------- References  Popup ------------------------------------------->
<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{row_name}}'s References</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="row_ref">
        <p [innerHTML]="row_ref"></p>
      </div>
      <div *ngIf="!row_ref">
        Data not found!
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div>
  </ng-template>
</div>

<!-------------- Contacts list  Popup ------------------------------------------->
<div>
  <ng-template #myModalContact let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{row_name}}'s Contacts</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ngx-datatable [rows]="row_contacts" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="10"
        [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
        <ngx-datatable-column name="Name" prop="name" [width]="50">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <div class="d-flex align-items-center">
              {{row?.name}}
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Email" prop="email" [width]="30">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            {{row?.email }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Phone" prop="phone" [width]="10">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <span>{{row?.phone}}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Action" [width]="10">
          <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
            <i class="ft-edit text-primary cursor-pointer" (click)="updateContact(row?._id)"></i>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div>
  </ng-template>
</div>
